import React from 'react'
import { withRouter } from 'react-router-dom'
import { SmallDown, SmallUp } from 'components/Responsive/breakpoints'
import DefaultDriverDesktopLayout from 'components/layout/DefaultDriverDesktopLayout'
import ServiceStandardsContent from 'components/DriversApp/ServiceStandardsContent'

const ServiceStandards = ({ history }) => {
  const renderDocument = () => (
    <div className='driver-booking-container' style={{ margin: 0 }}>
      <div className='driver-service-card assign-card partner-document-card'>
        <div className='partner-document-body'>
          <ServiceStandardsContent />
        </div>
      </div>
    </div>
  )

  return (
    <>
      <SmallUp>
        <DefaultDriverDesktopLayout
          data={{ name: 'Service Standards' }}
          renderContent={renderDocument}
        />
      </SmallUp>
      <SmallDown>
        <div className='driver-edit-container partner-document-mobile'>
          <img
            className='driver-back-icon-account'
            src='/images/icon-back.png'
            onClick={history.goBack}
            alt=''
          />
          <div className='driver-booking-container-header'>
            Service Standards
          </div>
          <div className='partner-document-mobile-body'>{renderDocument()}</div>
        </div>
      </SmallDown>
    </>
  )
}

export default withRouter(ServiceStandards)
